import AsyncStorage from "@react-native-async-storage/async-storage";
import { randomUUID } from "expo-crypto";
import * as SecureStore from "expo-secure-store";
import { Platform } from "react-native";

const INSTALLATION_KEY = "installation-id";

// Add every SecureStore key your app uses
const SECURE_STORE_KEYS = ["auth-store"];

export async function initializeInstallation() {
  const installationId = await AsyncStorage.getItem(INSTALLATION_KEY);

  // First launch after install
  if (!installationId) {
    // Remove any Keychain items left from a previous install
    if (Platform.OS === "web") {
      await Promise.all(
        SECURE_STORE_KEYS.map((key) => AsyncStorage.removeItem(key)),
      );
    } else {
      await Promise.all(
        SECURE_STORE_KEYS.map((key) => SecureStore.deleteItemAsync(key)),
      );
    }

    await AsyncStorage.setItem(INSTALLATION_KEY, randomUUID());
    return true;
  }
  return false;
}
